import React, { useEffect, useMemo, useState, useRef } from "react";
import Stats from '../../Components/Stats';
import CustomTable from "../../Components/CustomTable";
import { getCustomerList } from '../../api';
import moment from "moment";
import { Loader } from "../../Components/Loader";


const normalizeUsers = (items) => {
  if (!Array.isArray(items)) return [];
  return items.map((item) => {
    const firstName = item.first_name || item.firstName || item.name || '';
    const lastName = item.last_name || item.lastName || '';
    const fullNameFromParts = `${firstName} ${lastName}`.trim();
    const fullName = item.full_name || fullNameFromParts || item.username || 'N/A';
    const email = item.email || 'N/A';
    const rawPhone = item.phone || item.phone_number || item.mobile || '';
    const phone = item.phone_country_code ? `${item.phone_country_code} ${rawPhone || ''}`.trim() : (rawPhone || 'N/A');
    const address = item.address || item.city || '';
    const gender = item.gender || 'N/A';
    const status = item.status || item.license_status || item.latest_license_status || 'N/A';
    return { name: fullName, email, phone, address, gender, status };
  });
};

export default function UserManagement() {
  const [globalFilter, setGlobalFilter] = useState("");
  const [pageIndex, setPageIndex] = useState(1);
  const pageSize = 10;
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [startDate, setStartDate] = useState(moment().startOf("month").format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
const [pageData,setPageData]=useState('')


  const debounceTimeoutRef = useRef(null);

  const fetchUsers = async ({  start=startDate, end=endDate,isSearch }) => {
    try {
      if(isSearch){
        setLoading(false);
      }
      else{
        setLoading(true);
      }
      
      setError("");
     
      const items = await getCustomerList({ search:globalFilter, start_date: start, end_date: end,page:pageIndex });
      
      setUsers(items?.data?.data);
      setPageData(items?.data?.page_data)
    } catch (e) {
      
        setError(e.message || 'Failed to load users');
        setUsers([]);
    
    } finally {
      setLoading(false);
    }
  };

  // Debounced effect for globalFilter changes
  useEffect(() => {
    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }
    
    debounceTimeoutRef.current = setTimeout(() => {
      fetchUsers({ start: startDate, end: endDate ,isSearch:true});
    }, 500); // 500ms debounce delay

    return () => {
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current);
      }
    };
  }, [globalFilter]);

  

  useEffect(() => {
    // initial load
    fetchUsers({  start: startDate, end: endDate });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageIndex]);


  



  const columns = useMemo(
    () => [
      { key: "sno", label: "S.No.", minWidth: "36px", width: "36px", render: (_, __, idx) =>    idx+1   ,showSortIcon: false},
      { key: "name", label: "NAME", minWidth: "110px", width: "110px" , showSortIcon: false},
      { key: "email", label: "EMAIL", minWidth: "159px", width: "159px" , showSortIcon: false},
      { key: "phone", label: "PHONE NUMBER", minWidth: "128px", width: "128px" , showSortIcon: false},
      { key: "address", label: "ADDRESS", minWidth: "159px", width: "159px" , showSortIcon: false},
      { key: "gender", label: "GENDER", minWidth: "79px", width: "79px", showSortIcon: false },
      {
        key: "status",
        label: "LICENSE STATUS",
        minWidth: "132px",
        width: "132px",
        render: (value) => (
          <span
            className={
              value === "approved"
                ? "px-3 py-1 rounded-full text-xs font-normal bg-gradient-to-b from-[#0EBC651A] to-[#0EBC6500] text-[#0EBC65]"
                : value === "Rejected"
                ? "px-3 py-1 rounded-full text-xs font-normal bg-gradient-to-b from-[#FF56301A] to-[#FF563000] text-[#FF5630]"
                : "px-3 py-1 rounded-full text-xs font-normal bg-gradient-to-b from-[#F3B7531A] to-[#F3B75300] text-[#F3B753]"
            }
          >
            {value}
          </span>
        ),showSortIcon: true
      },
    ],
    [pageIndex, pageSize]
  );


  const handleStartDate = (date) => {

    
    setStartDate(moment(date).format("YYYY-MM-DD"));
  };
  const handleEndDate = (date) => {
    setEndDate(moment(date).format("YYYY-MM-DD"));
  };

const searchUser =()=>{
  fetchUsers({ search:globalFilter, start: startDate, end: endDate });
}

if(loading){
  return <Loader/>
}
  return (
    <div className="flex flex-col gap-4 p-8 bg-[#161616] min-h-screen">
      <Stats handleStartDate={handleStartDate} handleEndDate={handleEndDate} handlegetData={searchUser} startDate={startDate} endDate={endDate} showtiles={false}/>
      <div className="flex items-center gap-4">
       
       
        {loading && <span className="text-xs text-[#bdbdbd]">Loading...</span>}
        {error && <span className="text-xs text-red-400">{error}</span>}
      </div>
      <CustomTable

        data={normalizeUsers(users)}
        columns={columns}
        showSortIcon={true}
        pageIndex={pageIndex}
        setPageIndex={setPageIndex}
        pageSize={pageSize}
        globalFilter={globalFilter}
        setGlobalFilter={setGlobalFilter}
        disableClientFilter={true}
        pageData={pageData}
      />
    </div>
  );
}
